import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import {
  AddClubPlanPayload,
  ManagePremiumStoreInfoPayload,
  PremiumStores,
  StoreDeletePayload,
  ToggleStatusPayload,
  UpdateAdminPlanPayload,
  UpdateClubPlanPayload,
  UpdateClubPlanStatusPayload,
} from './premiumStores.types';

const togglePremiumStoresStatus = (client: AxiosInstance) => async (payload: ToggleStatusPayload) => {
  return (
    await client.post<{ message: string; data: PremiumStores }>(API_ROUTES.BLOCK_UNBLOCK_PREMIUM_STORE_INFO, {
      clubId: payload.clubId,
      status: payload.status,
    })
  ).data;
};

const approvePremiumStoreInfo = (client: AxiosInstance) => async (holdId: string) => {
  return (
    await client.post<{ message: string; data: PremiumStores }>(API_ROUTES.APPROVE_PREMIUM_STORE_INFORMATION, {
      holdId: holdId,
    })
  ).data;
};

const rejectPremiumStoreInfo = (client: AxiosInstance) => async (holdId: string) => {
  return (
    await client.post<{ message: string; data: PremiumStores }>(API_ROUTES.REJECT_PREMIUM_STORE_INFORMATION, {
      holdId: holdId,
    })
  ).data;
};

const createPremiumStoreInfo = (client: AxiosInstance) => async (payload: ManagePremiumStoreInfoPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.ADD_PREMIUM_STORE, payload)).data;
};

const managePremiumStoreInfo = (client: AxiosInstance) => async (payload: ManagePremiumStoreInfoPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.UPDATE_PREMIUM_STORE_INFO, payload)).data;
};

const deletePremiumStoreInfo = (client: AxiosInstance) => async (payload?: StoreDeletePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.DELETE_PREMIUM_STORE_INFO, payload)).data;
};

const resetPremiumStorePassword = (client: AxiosInstance) => async (clubId: string) => {
  return (await client.post<{ message: string }>(API_ROUTES.RESET_PREMIUM_STORE_PASSWORD, { clubId: clubId })).data;
};

const addClubPlan = (client: AxiosInstance) => async (payload: AddClubPlanPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.ADD_CLUB_PLAN, payload)).data;
};

const updateClubPlan = (client: AxiosInstance) => async (payload: UpdateClubPlanPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.UPDATE_CLUB_PLAN, payload)).data;
};

const updateClubPlanStatus = (client: AxiosInstance) => async (payload: UpdateClubPlanStatusPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.UPDATE_CLUB_PLAN_STATUS, payload)).data;
};

const updateAdminPlan = (client: AxiosInstance) => async (payload: UpdateAdminPlanPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.UPDATE_ADMIN_PLAN, payload)).data;
};

export const premiumStoresMutations = {
  togglePremiumStoresStatus,
  approvePremiumStoreInfo,
  rejectPremiumStoreInfo,
  createPremiumStoreInfo,
  managePremiumStoreInfo,
  deletePremiumStoreInfo,
  resetPremiumStorePassword,
  addClubPlan,
  updateClubPlan,
  updateClubPlanStatus,
  updateAdminPlan,
};
